export class CreateBookingNoAdvanceFeeDto {
    readonly basket_id: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawData: any) {
        this.basket_id = rawData.basket_id;
    }
}
